import { useState } from 'react';

import Modal from '/components/ui/Modal';
import Heading from '/components/ui/typography/Heading';
import Paragraph from '/components/ui/typography/Paragraph';
import Button from '/components/ui/buttons/Button';

interface Props {
    onClose: () => void;
    onSubmit: (revisionRequired: boolean) => Promise<any>;
}

export default function SellerConfirmationModal({ onClose, onSubmit }: Props) {
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [submittingWithRevisionFlag, setSubmittingWithRevisionFlag] =
        useState<boolean>(false);

    return (
        <Modal className="p-32" closeRequestCallback={onClose}>
            <Heading
                centered
                size="large"
                as="div"
                className="mb-24"
                style={{ padding: '0 33px' }}
            >
                Klarte kunden å svare på alle spørsmålene?
            </Heading>
            <Paragraph centered size="medium" className="mb-48">
                Jobben blir lagt i handlekurven selv om du mangler svar.
            </Paragraph>
            <div className="flex wrap children-full-width-on-mobile">
                <Button
                    className="mr-8"
                    style={{ width: 'calc(50% - 8px)' }}
                    busy={submitting}
                    onClick={async () => {
                        if (submitting) return;
                        setSubmitting(true);
                        await onSubmit(false);
                        setSubmitting(false);
                        onClose();
                    }}
                >
                    Fikk svar på alt
                </Button>
                <Button
                    variant="tertiary"
                    className="ml-8"
                    style={{ width: 'calc(50% - 8px)' }}
                    busy={submittingWithRevisionFlag}
                    onClick={async () => {
                        if (submittingWithRevisionFlag) return;
                        setSubmittingWithRevisionFlag(true);
                        await onSubmit(true);
                        setSubmittingWithRevisionFlag(false);
                        onClose();
                    }}
                >
                    Mangler svar
                </Button>
            </div>
        </Modal>
    );
}
